/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { DatePicker, DatePickerProps } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useField } from 'formik';

import FieldLayout from '../FieldLayout/FieldLayout';

import styles from './styles.less';

type Props = DatePickerProps & {
  name: string;
  label?: string | React.ReactNode;
  inline?: boolean;
  format?: string;
  showTime?: boolean;
  onChange?: (value: Dayjs | null, dateString: string) => void;
  errorPosition?: 'default' | 'bottom';
};

function AntDatePickerField({
  name,
  label,
  inline,
  onChange,
  showTime,
  errorPosition,
  size = 'small',
  ...props
}: Props) {
  const [, meta, helpers] = useField(name);
  const isError = meta.touched && meta.error !== undefined;

  const onChangeDate: DatePickerProps['onChange'] = (value, dateString) => {
    helpers.setValue(value);
    onChange?.(value, dateString);
  };

  return (
    <FieldLayout
      isError={isError}
      inline={inline}
      label={label}
      errorMessage={meta.error}
      errorPosition={errorPosition}>
      <DatePicker
        className={styles.datePicker}
        {...props}
        value={meta.value ? dayjs(meta.value) : null}
        onChange={onChangeDate}
        showTime={showTime ? { format: 'HH:mm' } : false}
        size={size}
      />
    </FieldLayout>
  );
}

export default AntDatePickerField;
